'use client';

import type { ChangeEvent } from 'react';

import GenderFemale from '../../../../../public/images/tests/gender-female.svg';
import GenderMale from '../../../../../public/images/tests/gender-male.svg';

type Props = {
    selected?: string;
    onSelect?: (selected: string) => void;
};

export default function GenderSelection({ selected, onSelect }: Props) {
    const radioClassName = 'mt-2 h-4 w-4 md:h-6 md:w-6 cursor-pointer';
    const labelClassName = (value: string) =>
        `${
            value === 'feminin' ? 'bg-light-yellow' : 'bg-light-green'
        }  flex w-1/2 cursor-pointer items-center overflow-hidden lg:w-[400px] ${
            selected === value ? ` ring-primary ring-1 shadow-lg z-10` : ''
        }`;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onSelect?.(event.target.value);
    };

    return (
        <div id="gender-selection">
            <h2 className="py-4 text-center text-2xl md:py-8 md:text-4xl lg:my-16 lg:text-6xl">Selectează</h2>
            <div className="container mx-auto flex items-end text-lg md:gap-10 md:px-4 md:text-xl lg:w-fit">
                <label htmlFor="radio-female" className={labelClassName('feminin')}>
                    <div className="relative h-40 w-1/2 pt-4 md:h-auto md:pt-8">
                        <GenderFemale className="absolute bottom-0 right-0 inline-block w-32 md:static md:w-48" />
                    </div>
                    <div className="w-1/2 text-center">
                        <div>Feminin</div>
                        <input
                            id="radio-female"
                            type="radio"
                            name="radio-gender"
                            className={radioClassName}
                            value="feminin"
                            checked={selected === 'feminin'}
                            onChange={handleChange}
                        />
                    </div>
                </label>
                <label htmlFor="radio-male" className={labelClassName('masculin')}>
                    <div className="w-1/2 text-center">
                        <div>Masculin</div>
                        <input
                            id="radio-male"
                            type="radio"
                            name="radio-gender"
                            className={radioClassName}
                            value="masculin"
                            checked={selected === 'masculin'}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="relative h-40 w-1/2 pt-4 text-right md:h-auto md:pt-8">
                        <GenderMale className="absolute bottom-0 left-0 inline-block w-32 md:static md:w-48" />
                    </div>
                </label>
            </div>
        </div>
    );
}
